// extracted by mini-css-extract-plugin
export default {"container":"cartBundleOrder_container__Xre53","heading":"cartBundleOrder_heading__pw-RF"};